import { PlusIcon } from "@heroicons/react/24/outline";
import { IPolicy, PolicyType } from "shared";
import { useNavigate } from "react-router";

import { classNames } from "../../../../../common/lib/classNames";
import { useCreatePolicyMutation } from "../../../../services/api/policyApi/policy";
import { useGetSelectedOrganisation } from "../../../../hooks/useGetSelectedOrganisation";
import { useCurrentGroup } from "../../../../hooks/useGroups";
import { useGroups } from "../../../../hooks/useGroups";
import { usePolicies } from "../../../../hooks/usePolicies";

interface AddNewPolicyCardProps {
  policyType: PolicyType;
  label: string;
  defaultOptions?: Partial<IPolicy>;
}

export function AddNewPolicyCard({ policyType, label, defaultOptions }: AddNewPolicyCardProps) {
  const [createPolicy, { isLoading }] = useCreatePolicyMutation();
  const currentOrg = useGetSelectedOrganisation();
  const { groupFormData } = useCurrentGroup();
  const { refetch: groupRefetch } = useGroups();
  const { refetch: policyRefetch } = usePolicies();
  const navigate = useNavigate();

  async function handleCreate() {
    try {
      const res = await createPolicy({
        type: policyType,
        organisationId: currentOrg.id,
        groupId: groupFormData.id,
        defaultOptions,
      }).unwrap();

      await Promise.all([
        groupRefetch().unwrap(),
        policyRefetch().unwrap(),
      ]);

      const policy = res?.policy;
      if (policy) {
        navigate(`/${currentOrg?.id}/groups/${groupFormData.id}/policies/${policy.id}`);
      }
    }
    catch (error) {
      console.error(`Failed to create policy:`, error);
    }
  }

  return (
    <button
      onClick={ handleCreate }
      disabled={ isLoading }
      className={ classNames(
        `text-left border-2 border-dashed border-gray-200 p-4 rounded-md w-full cursor-pointer bg-white hover:border-paidniceGreen-400 hover:bg-paidniceGreen-50 transition-colors`,
        isLoading && `opacity-50 cursor-wait`,
      ) }
    >
      <div className={ `flex items-center justify-center gap-2 text-gray-500 hover:text-paidniceGreen-600` }>
        <PlusIcon className={ `h-5 w-5` } />
        <span className={ `text-sm font-small` }>{ label }</span>
      </div>
    </button>
  );
}
